import React, { useState, useEffect } from "react";
import "./index.scss";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setBearerToken } from "../../helpers/functions";
import LOGO from "../../assets/images/DERMASTER_NEW_LOGO.png";

const LoginPage = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onLogout = async () => {
    localStorage.removeItem("token");

    setBearerToken(axios, true);

    dispatch({
      type: "UPDATE_USER",
      data: {},
    });

    // history.push(`/`);
    window.location.href = "/";
  };

  useEffect(() => {
    onLogout();
  }, []);

  return (
    <div className="login">
      <div className="container">
        <img className="logo" src={LOGO} alt="Dermaster" />
        <div className="box">
          <div className="box-contant">
            <label className="label">กำลังออกจากระบบ</label>
            <p className="text-gray text-loading">กรุณารอสักครู่...</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
